import getCookie from "./getCookie";

const loginFormId = "frontend-login-form";

let onBiometricPromptShow = () => {
  console.log("onBiometricPromptShow");
  window.VueApp.$refs.biometricSignInDialog.open();
};

let onBiometricPromptHide = () => {
  console.log("onBiometricPromptHide");
  window.VueApp.$refs.biometricSignInDialog.close();
};

let receiveBiometricDataStatus = (status) => {
  console.log("receiveBiometricDataStatus", status);
  if (status === "yes" && window.VueApp.$refs.showBiometricModalBtn) {
    window.VueApp.$refs.showBiometricModalBtn.classList.remove("d-none");
    // window.webView.showBiometricPrompt();
  }
};

let submitLoginForm = (e) => {
  let email = e.target.elements["email"].value;
  let password = e.target.elements["password"].value;
  console.log("submitLoginForm");
  if (email && password) {
    window.osAdapter.setCredentials(JSON.stringify({ username: email, password: password }));
    console.log("setCredentials");
  }

  return true;
};

let clearBiometricData = () => {
  let basicAlertMessage = document.getElementById("basic-alert-message");
  let loginForm = document.getElementById(loginFormId);
  let errors = loginForm ? loginForm.getElementsByClassName("hint--error") : null;

  if (basicAlertMessage || (errors && errors.length > 0)) {
    window.osAdapter.clearBiometricData();
    console.log("clearBiometricData");
  }
};

export function supportBiometric() {
  let supportBiometric = getCookie("SUPPORTS_BIOMETRIC");
  return supportBiometric === "true" || supportBiometric === true;
}

export default function biometricLogin() {
  if (
    !supportBiometric() ||
    !window.VueApp.$refs.biometricSignInDialog ||
    !window.location.pathname.includes("/login")
  ) {
    return null;
  }

  window.VueApp.onBiometricPromptShow = onBiometricPromptShow;
  window.VueApp.onBiometricPromptHide = onBiometricPromptHide;
  window.VueApp.receiveBiometricDataStatus = receiveBiometricDataStatus;
  //
  let loginForm = document.getElementById(loginFormId);
  if (loginForm) {
    loginForm.addEventListener("submit", submitLoginForm);
  }
  //
  clearBiometricData();
  //
  window.osAdapter.hasBiometricData();
}
